import {mediaShareService} from '_app/services';
import {addAlert} from '_app/shared/features/TransientNotifications/TransientNotificationsActions';
import {SHARE_LINK_FETCH_SUCCESS} from './shareLinksConstants';

const fetchShareLinkSuccess = shareLink => ({
	type: SHARE_LINK_FETCH_SUCCESS,
	data: {
		shareLink
	}
});

export const fetchShareLink = (id, version, advisorId, type, advisorPartnerId) => dispatch => {
	return mediaShareService.link(id, version, advisorId, type, advisorPartnerId)
		.then(data => dispatch(fetchShareLinkSuccess({
			id: id,
			version: version,
			link: data.link,
			text: data.shareText,
			type: data.shareType,
			advisorId
		})))
		.catch((xhr, message) => dispatch(addAlert(message)));
};

export const addShareItem = (id, token, advisorId, shareType, advisorPartnerId) => dispatch => {
	return mediaShareService.add(id, token, advisorId, shareType, advisorPartnerId)
		.catch(function(jqXHR, message) {
			dispatch(addAlert('Error sharing item: ' + message));
		});
};